import { TabsComponent } from './Tabs'

export type { TabsProps } from './Tabs'
export * from './TabsContext'

export const Tabs = TabsComponent
